export const SDK_VERSION = '7.44.2';
